import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { EmailTemplatesService } from 'src/app/services/administration/email-templates.service';
import { CommonService } from 'src/app/services/common.service';
import { AlertsAndNotificationsServiceService } from 'src/app/services/common/alerts-and-notifications-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-email-templates-model-view',
  templateUrl: './email-templates-model-view.component.html',
  styleUrls: ['./email-templates-model-view.component.scss']
})
export class EmailTemplatesModelViewComponent implements OnInit {

  EmailTemplatesForm: UntypedFormGroup;
  ApplicableProgrmaslst:any[];
  ApplicableProgrmaslst1:any[];
  ToCCPlaceHolders:any[];
  ApplicationTypeList:any[];
  SubBodyPlaceHolders:any[];
  SubjectTooltipOutput:any;
  Heading:string;
  SaveButton:string;
  CancelButton:string;
  content:  string ;
  HideSave:boolean = true;
  EmailTemplate:any = {};
  singlerecord:any;
  tootipValue:any;
    appTypetooltipValue:any;
  moduleID: any;

  action: Subject<any> = new Subject();

  @Input() Content:any; 

  editorInit: Record<string, any> | undefined = {
    base_url: '/tinymce',
    selector: 'editor#bodyeditor',
    suffix: '.min',
    statusbar: false,
    height: '200px !important',
    readonly: 1,
    paste_data_images: true,
    menubar: true,
    toolbar: true,
    plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks fullscreen',
        'insertdatetime media table paste'
    ]
  };
  MappedApplications: any[] = [];

  constructor(private fb: UntypedFormBuilder,
    public modalRef: NgbActiveModal,
    private emailtemplatesservice:EmailTemplatesService,
    private anservice:AlertsAndNotificationsServiceService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private userService:UserService) {
      this.EmailTemplatesForm = this.fb.group({
        EmailTempID: [null],
        TName: ["", [Validators.required, Validators.maxLength]],
        ApplicableProgram:["", [Validators.required]],
        EmailTo: ["", [Validators.required]],
        EmailCC: [""],
        EmailBCC: [""],
        EmailSubject: ["", [Validators.maxLength(1000), this.IsEmptySpaces]],
        EmailBody: [""],
        Active: [true],
        EmailToPlaceHolders: [null, [Validators.required]],
        EmailCCPlaceHolders: [null],
        ApplicationType: ["", [Validators.required]],

      }); 
    }

  ngOnInit(): void {
    this.getApplicablePrograms();
    this.Heading = this.Content.heading;
    this.SaveButton = this.Heading == 'Add'? 'Add':'Save';
    this.HideSave = this.Heading == 'View'? true : false;
    this.CancelButton = this.Heading == 'View'? 'Close':'Cancel';

    if(this.Heading == 'View' || this.Heading == 'Edit'){
      this.getemailtemplatebyid();
      if(this.Heading == 'View'){
          this.EmailTemplatesForm.disable();
      }
    }
  //   this.ApplicationTypeList = [{
  //     "label" : "ISTType001",
  //     "value": "IST001"
  // }]
    // this.getApplicationtypes();
  }

  changeAppTypes(event)
  {
    setTimeout(() => {
      let selectedProg ;
      if (event == "default") {
        this.MappedApplications=[];
        this.EmailTemplatesForm.controls["ApplicationType"].setValue([]);
        this.ApplicationTypeList.forEach(element => {
          this.MappedApplications.push(element.value);
        });
        this.EmailTemplatesForm.controls["ApplicationType"].setValue(this.MappedApplications);
        selectedProg = this.EmailTemplatesForm.controls["ApplicationType"].value;
      }
        selectedProg = this.EmailTemplatesForm.controls["ApplicationType"].value;
        if (selectedProg != "" && selectedProg != undefined && selectedProg != null) {
          let TypeLabel = this.ApplicationTypeList.filter((item) => {
            return selectedProg.indexOf(item.value) > -1;
          })
           let labellist=[];
           TypeLabel.forEach((item)=>{
            labellist.push(item.label);
          });
           this.appTypetooltipValue =labellist.join(",");
        }
        else
        {
          this.appTypetooltipValue = "";
        }
    }, 200);
  }
  

  changeVal($event) {
    setTimeout(()=>{
    let selectedMailIds= this.EmailTemplatesForm.controls["EmailToPlaceHolders"].value;
    if(selectedMailIds != "" && selectedMailIds != undefined && selectedMailIds != null)
      {
        let userName=this.ToCCPlaceHolders.filter((item)=>{
          return  selectedMailIds.indexOf(item.value)>-1;
         })
         let labellist=[];
         userName.forEach((item)=>{
           labellist.push(item.label);
         });
         this.tootipValue =labellist.join(",");
      }
      else
      {
        this.tootipValue = "";
      }
    }, 200);

  } 

  IsEmptySpaces(c: UntypedFormControl) {
    if (!c.value || !c.value.trim()) {
        return { valid: false };
    }
    return { valid: true };
  }

  getApplicablePrograms(){
    this.emailtemplatesservice.getApplicablePrograms(this.userService.getOrgCode()).subscribe(result=>{
      if(result != null && result != undefined){
        this.ApplicableProgrmaslst = result;
        // this.ApplicableProgrmaslst =[{label:'Select' , value :''}].concat(this.ApplicableProgrmaslst);
      }
    });
  }

  applicableprogramchange(ProgramValue:string,OperationType:string = ""){
    debugger;
    this.moduleID = ProgramValue;
    
    this.getApplicationtypes();
      if(ProgramValue!=='' && ProgramValue != undefined && ProgramValue != null){
        this.anservice.getanplaceholders(ProgramValue).subscribe(result=>{
          if(result != null && result != undefined){
            this.ToCCPlaceHolders = result.filter(function (a) {
              return (a.phtype == 'TO_CC')
            });

            this.SubBodyPlaceHolders = result.filter(function (a) {
              return (a.phtype == 'OTHERS')
            });

            this.SubjectTooltipOutput = this.SubBodyPlaceHolders.map(
              (x) => x.label
          ).join("\r\n");
          }

          if(OperationType != "Edit"){
            this.EmailTemplatesForm.patchValue({
              EmailTempID: this.Content.content.EmailTempID,
              TName:null,
              EmailTo: null,
              EmailCC: null,
              EmailBCC: null,
              Active: true,
              EmailToPlaceHolders: null,
              EmailCCPlaceHolders: null,
              EmailSubject: null,
              EmailBody: null,
            });
          }
        });
      }
      else{
        this.ToCCPlaceHolders = [];
        this.SubjectTooltipOutput= "";
        this.ApplicationTypeList =[];
        this.EmailTemplatesForm.controls["ApplicationType"].setValue([]);
        this.EmailTemplatesForm.controls["EmailToPlaceHolders"].setValue([]);
      }
  }

  save() {
    if (this.ValidateForm()) {
      if ((this.EmailTemplatesForm.dirty || this.EmailTemplatesForm.touched)) {
        let model = this.EmailTemplatesForm.getRawValue();
        if(model.ApplicationType!=null)
        {
          model['MappedAppTypesIDs'] = model.ApplicationType?.join(",");
        }
        let tempList = this.ApplicationTypeList.filter((item) => {
          return   model['MappedAppTypesIDs'].indexOf(item.value) > -1;
        });
        tempList.forEach((obj, index) => {
          if (index == 0)
            model['MappedAppTypesNames'] = obj.label;
          else
            model['MappedAppTypesNames'] = model['MappedAppTypesNames'] + "," + obj.label;
        });

        this.EmailTemplate = {
            EmailTempID: this.Content.content.EmailTempId == undefined ? null:this.Content.content.EmailTempId,
            ModuleId:model.ApplicableProgram,
            Name: model.TName,
            RecordState: model.Active,
            EmailTo: model.EmailTo,
            ToPlaceHolders: model.EmailToPlaceHolders,
            EmailCc: model.EmailCC,
            CcPlaceHolders: model.EmailCCPlaceHolders,
            EmailBcc:model.EmailBCC,
            EmailSubject: model.EmailSubject,
            EmailBody: model.EmailBody,
            OperationType:this.Heading,
            MappedAppTypesIDs: model['MappedAppTypesIDs'],
            MappedAppTypesNames : model['MappedAppTypesNames']
            //            ApplicationType:model.ApplicationType,
        };
        
        this.emailtemplatesservice.SaveEmailTemplate(this.EmailTemplate).subscribe(
            result => {
                if (result != null && result != undefined) {
                    if (result.Status) {
                        this.commonService.SuccessBanner(result.errMessage);
                      //  this.action.next();
                        this.modalRef.close();
                    } else {
                      this.commonService.ValidationBanner(result.errMessage);
     
                    }
                } else {
                  this.commonService.ValidationBanner("Unable to save");
  
                }
            },
            (err) => {
              this.commonService.ValidationBanner(err);
 
            }
        );
    } else {
        if(this.Content.heading === "Edit"){
          this.commonService.ValidationBanner("No changes have been performed");
   
        }
    }
    }
  }

  ValidateForm() {
    let err: string = '';
    var EmailPattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$");
    if (!this.EmailTemplatesForm.valid) {

      if (!this.EmailTemplatesForm.controls['ApplicableProgram']?.valid) {
        if (this.EmailTemplatesForm.controls['ApplicableProgram'].value == null || 
          this.EmailTemplatesForm.controls['ApplicableProgram'].value <= 0) {
            err += ("Please select Applicable Program<br/>");
        }
      }
      if (!this.EmailTemplatesForm.controls['ApplicationType']?.valid) {
        if (this.EmailTemplatesForm.controls['ApplicationType'].value == null || 
          this.EmailTemplatesForm.controls['ApplicationType'].value <= 0) {
            err += ("Please select Application Type<br/>");
        }
      }
      if(this.EmailTemplatesForm.controls['ApplicationType']?.value!=null && this.EmailTemplatesForm.controls['ApplicationType']?.value!=undefined && this.EmailTemplatesForm.controls['ApplicationType']?.value!="")
      {
        let selectedIDs = this.EmailTemplatesForm.controls['ApplicationType']?.value.join(",")
        let InactiveAvilable = this.ApplicationTypeList.filter((item) => {
          return (selectedIDs.indexOf(item.value) > -1 && item.IsActive == false);
        })[0];
        if (InactiveAvilable != undefined && InactiveAvilable != null) {
          err += "Please remove inactive application type to save the details<br/>";
        }
      }

        if (!this.EmailTemplatesForm.controls['TName']?.valid) {
            if (this.EmailTemplatesForm.controls['TName'].errors?.required) {
                err += ("Please enter Template Name <br/>");
            }
            if (this.EmailTemplatesForm.get('TName')?.errors?.maxLength) {
                err += ("Length of Template name should not exceed 100 <br/>");
            }
        }
        else if(this.EmailTemplatesForm.controls['TName'].value!=null && this.EmailTemplatesForm.controls['TName'].value.trim()=="")
        {
          err += ("Please enter Template Name <br/>");
        }

        if (!this.EmailTemplatesForm.get('EmailToPlaceHolders')?.valid && !this.EmailTemplatesForm.get('EmailTo')?.valid) {
            err += ("Please enter To <br/>");
        }
        else if (this.EmailTemplatesForm.controls['EmailTo'].value) {
            let emailto = this.EmailTemplatesForm.controls['EmailTo'].value;
            if (emailto != null) { var emailtovalid = emailto.replaceAll(",", ";"); }
            if (!emailto) {
                err += ("Please enter To  <br/>");
            }
            else {
                let emailtoArr = emailtovalid.split(';');
                for (let i = 0; i < emailtoArr.length; i++) {
                  let isvalidemail = this.commonService.validateEmail(emailtoArr[i].trim())
                    if (!isvalidemail) {
                        err += ("Invalid Email Id in To - " + emailtoArr[i] + " <br/>");
                        break;
                    }
                }
            }
        }

        let emailcc = this.EmailTemplatesForm.controls['EmailCC'].value;
        if (emailcc != null) { var emailccvalidate = emailcc.replaceAll(",", ";"); }
        if (emailcc) {
            let emailccArr = emailccvalidate.split(';');
            for (let i = 0; i < emailccArr.length; i++) {
              let isvalidemail = this.commonService.validateEmail(emailccArr[i].trim())
                if (!isvalidemail) {
                    err += ("Invalid Email Id in CC - " + emailccArr[i] + " <br/>");
                    break;
                }
            }
        }

        let emailbcc = this.EmailTemplatesForm.controls['EmailBCC'].value;
        if (emailbcc != null) { var emailbccvalidate = emailbcc.replaceAll(",", ";"); }
        if (emailbcc) {
            let emailbccArr = emailbccvalidate.split(';');
            for (let i = 0; i < emailbccArr.length; i++) {
              let isvalidemail = this.commonService.validateEmail(emailbccArr[i].trim())
                if (!isvalidemail) {
                    err += ("Invalid Email Id in BCC - " + emailbccArr[i] +" <br/>");
                    break;
                }
            }
        }

        if (!this.EmailTemplatesForm.controls['EmailSubject']?.valid) {
          let EmailSubject = this.EmailTemplatesForm.controls['EmailSubject'].value;
          if(EmailSubject == null){
            err += ("Please enter Subject <br/>");
          }
          else if (!EmailSubject.trim()) {
            err += ("Please enter Subject <br/>");
          }

          if (this.EmailTemplatesForm.controls['EmailSubject']?.errors?.maxLength) {
              err += ("Length of Subject should not exceed 1000 <br/>");
          }
        }
    }
    else {
        let emailto = this.EmailTemplatesForm.controls['EmailTo'].value;
        if (emailto != null) { var emailtovalid = emailto.replaceAll(",", ";"); }
        if (!emailto) {
            err += ("Please enter To <br/>");
        }
        else {
            let emailtoArr = emailtovalid.split(';');
            for (let i = 0; i < emailtoArr.length; i++) {
              let isValidEmail=this.commonService.validateEmail( emailtoArr[i].trim());
                if (!isValidEmail) {
                    err += ("Invalid Email Id in To - " + emailtoArr[i] + " <br/>");
                    break;
                }
            }
        }

        let emailcc = this.EmailTemplatesForm.controls['EmailCC'].value;
        if (emailcc != null) { var emailccvalidate = emailcc.replaceAll(",", ";"); }
        if (emailcc) {
            let emailccArr = emailccvalidate.split(';');
            for (let i = 0; i < emailccArr.length; i++) {
              let isValidEmail = this.commonService.validateEmail(emailccArr[i].trim());
              if (!isValidEmail) {
                    err += ("Invalid Email Id in CC - " + emailccArr[i] + " <br/>");
                    break;
                }
            }
        }

        let emailbcc = this.EmailTemplatesForm.controls['EmailBCC'].value;
        if (emailbcc != null) { var emailbccvalidate = emailbcc.replaceAll(",", ";"); }
        if (emailbcc) {
            let emailbccArr = emailbccvalidate.split(';');
            for (let i = 0; i < emailbccArr.length; i++) {
              let isValidEmail = this.commonService.validateEmail(emailbccArr[i].trim());
              if (!isValidEmail) {
                    err += ("Invalid Email Id in BCC - " + emailbccArr[i] + " <br/>");
                    break;
                }
            }
        }
    }

    if (err.length > 0) {
      this.commonService.ValidationBanner(err);
      // this.modalService.show(MessageBoxComponent, {
      //   backdrop: false,
      //   keyboard: false,
      //   ignoreBackdropClick: true,
      //   animated: true,  
      //   data: { 
      //     heading: "Validation Message(s)", 
      //     content: { heading: '', description:err} 
      //   } 
      // });
      return false;
    }
    else {
        return true;
    }
  }

  getApplicationtypes(){
    let model = this.EmailTemplatesForm.getRawValue();
     this.moduleID = model.ApplicableProgram == "" ? this.moduleID : model.ApplicableProgram;    
    this.emailtemplatesservice.GetEmailApplicationTypes(this.moduleID, this.Content.content.EmailTempId).subscribe((result:any)=>{
      if(result)
        {
          this.ApplicationTypeList = result;
          if( this.Heading == "Add"){
              this.changeAppTypes("default");
          }

        }
    });
  }
 

  getemailtemplatebyid(){debugger;
    this.emailtemplatesservice.getEmailTemplateById(this.Content.content.EmailTempId).subscribe(result =>{
      if(result != null && result != undefined){
        this.singlerecord = result;
        if (this.singlerecord != null) {
            this.populatedatatocontrols();
        }
        this.changeVal(null);
        
      }

    });

 

  }

  populatedatatocontrols() {
   
    this.applicableprogramchange(this.singlerecord["ModuleId"],"Edit");

    if(this.singlerecord["MappedApplications"] != undefined && this.singlerecord["MappedApplications"] != null) {
      this.ApplicationTypeList = this.singlerecord["MappedApplications"];
      this.singlerecord["MappedApplications"].forEach(element => {
        this.MappedApplications.push(element.value);
      });
    }

    this.EmailTemplatesForm.patchValue({
        EmailTempID: this.Content.content.EmailTempID,
        TName: this.singlerecord["Name"],
        ApplicableProgram: this.singlerecord["ModuleId"],
        Active: this.singlerecord["RecordState"],
        EmailTo: this.singlerecord["EmailTo"],
        EmailToPlaceHolders: this.singlerecord["ToPlaceHoldersString"] == null ? null : this.singlerecord["ToPlaceHoldersString"].split(","),
        EmailCC: this.singlerecord["EmailCc"],
        EmailCCPlaceHolders: this.singlerecord["CcPlaceHoldersString"] == null ? null : this.singlerecord["CcPlaceHoldersString"].split(","),
        EmailBCC: this.singlerecord["EmailBcc"],
        EmailSubject: this.singlerecord["EmailSubject"],
        EmailBody: this.singlerecord["EmailBody"],
        ApplicationType:this.MappedApplications
    });

    this.EmailTemplatesForm.get("TName")?.disable();
    this.EmailTemplatesForm.get("ApplicableProgram")?.disable();

  }
}
